<div class="jobs">
	<div class="container">
		<div class="innerpage-heading">Jobs</div>
		<ul class="nav nav-pills job-list">
			<li class="active"> <a routerLink="/all-jobs">All Jobs</a> </li>
			<li><a routerLink="/applied-jobs">Applied Jobs</a> </li>
			<li><a routerLink="/saved-jobs">Saved Jobs</a> </li>
		</ul>
	</div>
	<!-- Recomanded Jobs OR Latest Jobs-->
	<section class="pd-tb-3">
		<div class="container">
			<h3 class="subheading flexcss"><span>{{jobsData?.recommandJob ? 'Recommended jobs':'Latest Jobs'}}
					<p class="para">Based on your profile and Search History</p>
				</span><a href="javascript:void(0);" class="orange flexcss" routerLink="/seeall"
					[queryParams]="{ type: 'latest'}">See all <img src="assets/images/arrow.svg"></a>
			</h3>
			<div class="row">
				<div class="col-12"
					*ngFor="let job of jobsData.recommandJob || jobsData.latestJobs">
					<!-- <div *ngIf="jobsData.length > 0"> -->
					<app-applied-saved-jobs-item [job]="job" [routerLink]="'/detail/' + job?.id"
						[queryParams]="{type: 'recommanded'}"
						(onJobSaved)="onJobSaved($event)"></app-applied-saved-jobs-item>
					<!-- </div> -->
				</div>
			</div>
			<div class="noDataFound" *ngIf="isPreferences=== 1 ? jobsData.recommandJob?.length == 0 : jobsData.latestJobs?.length == 0">
				<h2>No Records Found</h2>
			</div>
		</div>
	</section>
	<!-- End -->

	<!-- Employers of choice-->
	<section class=" choice pd-tb-3 pb-0">
		<div class="container p-0">
			<h3 class="subheading flexcss">Employers of Choice<a href="javascript:void(0);" class="orange flexcss">See
					all<img src="assets/images/arrow.svg"></a></h3>
			<div class="mainJob">
				<div class="greyBox pointer" *ngFor="let employer of jobsData.employersChoice"
					(click)="openEmployerDetails(employer.id)">
					<span class="featured">Featured</span>
					<img src="{{employer?.profileImage != null ? recruiterImagePath : ''}}{{employer?.profileImage == null ? 'assets/images/profile-img.jpg':employer.profileImage}}" alt="client">
				</div>
			</div>
		</div>
	</section>
	<!-- End -->

	<!-- Remote jobs-->
	<section class="pd-tb-3" *ngFor="let industry of jobsData.industriestList">
		<div class="container p-0" *ngIf="industry.listing.length > 0">
			<h3 class="subheading flexcss">
				<span> {{industry.title}} 
					<p *ngIf="industry.title == 'remote Jobs'" class="para">Because you expressed interest in remote
						work</p>
				</span>
				<a href="javascript:void(0)" class="orange flexcss" routerLink="/seeall"
					[queryParams]="{ type: 'indus'}">See all<img src="assets/images/arrow.svg"></a>
			</h3>
			<div class="row">
				<div class="col-xl-12 col-lg-12 col-md-6 col-sm-12 col-12" *ngFor="let job of industry.listing">
					<!-- <div *ngIf="jobsData.length > 0"> -->
					<app-applied-saved-jobs-item [job]="job" [routerLink]="'/detail/' + job?.id"
						[queryParams]="{type: 'industry',extras:industry.industryId }"
						(onJobSaved)="onJobSaved($event)"></app-applied-saved-jobs-item>
					<!-- </div> -->
				</div>
			</div>
		</div>
	</section>
	<!-- End -->
</div>